import { Injectable } from '@angular/core';

import { HttpClient } from './../http-client';
import { Config } from '../local/config';
import { UserData } from '../local/user-data';

/*
  Generated class for the LoanProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoanProvider {

  constructor(public http: HttpClient,
    public userData: UserData,
    public config: Config) {
    console.log('Hello LoanProvider Provider');
  }

  getLoans() {
    
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/alfa/reports`;
    let data = {spName: "report_loans", spParams: []};

    return this.http.post(link, data, 1)
    .then((res: any) => {
      console.log('Data report_loans', res.data)
      if(res && res.data && res.data.table) {
        res.data = res.data.table;
      }
      return res;
    });
  }

  getLoansByStatus(status: any) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/loans/status/${status}`;
    
    return this.http.get(link, 1);
  }

  getLoansByClient(id: any) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/customers/${id}/loans`;

    return this.http.get(link, 1);
  }

  getLoan(id) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/loans/${id}`;

    return this.http.get(link, 1);
  }

  create(data: any) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/loans`;

    return this.http.post(link, data, 1);
  }

  authorization(type: 'authorize'|'reject',  data: { loanId: any, authorizedAmount: any, reason?:any }) {

    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/loans/${type}`;

    return this.http.post(link, data, 1);

    /*{
      "loanId": 54,
      "authorizedAmount": 2000
    }*/
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/loan/loan.ts